import { Fragment, memo, useMemo } from "react";
import classNames from "classnames";

import { Box } from "@mantine/core";
import type { BoxProps } from "@mantine/core";

import { parseMentionText } from "./utils";

import type { MentionOption } from "./types";

import classes from "./styles.module.css";

export type MentionTextProps = Omit<BoxProps, "children"> & {
  value: string;
  mentions: MentionOption[];
  mask?: string;
  mentionClassName?: string;
};

const MentionText = (props: MentionTextProps) => {
  const { value, mentions, mask, className, mentionClassName, ...boxProps } =
    props;

  const parts = useMemo(
    () => parseMentionText(value, mentions, mask),
    [mask, mentions, value]
  );

  return (
    <Box
      component="span"
      {...boxProps}
      className={[classes.text, className].filter(Boolean).join(" ")}
    >
      {parts.map((part, index) =>
        part.type === "mention" ? (
          <span
            key={`${part.value}-${index}`}
            className={classNames(classes.mention, mentionClassName)}
            data-mention-id={part.mention.id}
          >
            {part.mention.label}
          </span>
        ) : (
          <Fragment key={`text-${index}`}>{part.value}</Fragment>
        )
      )}
    </Box>
  );
};

export default memo(MentionText);
